'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { AccordionitemProps, PhnxAccordionitem } from '../Accordionitem/Accordionitem'

interface AccordionitemBlokProps {
  blok: { title: AccordionitemProps['title']; content: SbBlokData[]; variant: any } & SbBlokData
}

const Accordionitem: FC<AccordionitemBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxAccordionitem
        title={blok.title}
        variant={blok.variant}
        content={
          blok.content &&
          blok.content.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
      />
    </div>
  )
}

export default Accordionitem
